import { Link } from 'react-router-dom';
import BottomSheet from '../base/BottomSheet';

interface PublicMoreSheetProps {
  open: boolean;
  onClose: () => void;
  onAssistantClick?: () => void;
}

export default function PublicMoreSheet({ open, onClose, onAssistantClick }: PublicMoreSheetProps) {
  const items = [
    { to: '/productos', label: 'Products', icon: 'ri-shopping-bag-3-line', color: 'text-teal-600' },
    { to: '/muestras/video', label: 'Videos', icon: 'ri-video-line', color: 'text-teal-600' },
    { to: '/ayuda', label: 'Help', icon: 'ri-question-answer-line', color: 'text-teal-600' },
    { to: '/terms.html', label: 'Terms', icon: 'ri-file-list-3-line', color: 'text-gray-600' },
    { to: '/ayuda', label: 'Contact', icon: 'ri-customer-service-2-line', color: 'text-teal-600' },
    {
      external: true,
      href: 'https://wa.me/17078066168',
      label: 'WhatsApp',
      icon: 'ri-whatsapp-line',
      color: 'text-green-600',
    },
  ];

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Más"
      maxHeight="70vh"
    >
      <div className="px-3 sm:px-4 py-3 grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
        {/* Asistente IA */}
        {onAssistantClick && (
          <button
            onClick={() => {
              onAssistantClick();
              onClose();
            }}
            className="flex flex-col items-center justify-center gap-1.5 p-2 sm:p-3 min-h-[64px] sm:min-h-[72px] bg-teal-50 hover:bg-teal-100 active:bg-teal-200 rounded-xl transition-colors cursor-pointer"
          >
            <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-teal-600">
              <i className="ri-robot-2-line text-lg sm:text-xl"></i>
            </div>
            <span className="text-[10px] sm:text-xs font-medium text-gray-700 text-center leading-tight">
              Asistente IA
            </span>
          </button>
        )}

        {items.map((item) =>
          item.external ? (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
              className="flex flex-col items-center justify-center gap-1.5 p-2 sm:p-3 min-h-[64px] sm:min-h-[72px] bg-gray-50 hover:bg-gray-100 active:bg-gray-200 rounded-xl transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg sm:text-xl`}></i>
              </div>
              <span className="text-[10px] sm:text-xs font-medium text-gray-700 text-center leading-tight">
                {item.label}
              </span>
            </a>
          ) : (
            <Link
              key={item.label}
              to={item.to!}
              onClick={onClose}
              className="flex flex-col items-center justify-center gap-1.5 p-2 sm:p-3 min-h-[64px] sm:min-h-[72px] bg-gray-50 hover:bg-teal-50 active:bg-teal-100 rounded-xl transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg sm:text-xl`}></i>
              </div>
              <span className="text-[10px] sm:text-xs font-medium text-gray-700 text-center leading-tight">
                {item.label}
              </span>
            </Link>
          )
        )}
      </div>
    </BottomSheet>
  );
}